module.exports = __webpack_public_path__ + "static/media/icono_mariachi.ec3c0396.svg";